// =============================================================================
// STOCKS BLOCK JAVASCRIPT - Three Card Toggle Approach
// =============================================================================

/**
 * Stocks Block functionality for TradingView integration
 * Three separate stock cards that toggle to show full charts
 */

let loadedStocks = new Set();

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    // Find all stock blocks on the page
    const stockBlocks = document.querySelectorAll('.stocks-container');
    
    stockBlocks.forEach(block => {
        // Load the first stock by default for each block
        const firstCard = block.querySelector('.stock-toggle-card.active');
        if (firstCard) {
            const contentId = firstCard.getAttribute('onclick').match(/'([^']+)'/)[1];
            loadStockData(contentId, firstCard);
            loadedStocks.add(contentId);
        }
        
        // Load price data for all cards in this block
        const cards = block.querySelectorAll('.stock-toggle-card');
        cards.forEach(card => {
            const symbol = card.getAttribute('data-symbol');
            const label = card.getAttribute('data-label');
            // updatePriceDisplay(card, symbol, label);
        });
    });

    // Enable interaction with TradingView/container iframes after user clicks
    document.addEventListener('click', function(event) {
        const container = event.target.closest('.tradingview-widget-container');
        if (container) {
            container.classList.add('interactive');
        }
    });
});

// Update price display in card
function updatePriceDisplay(card, symbol, label) {
    const priceInfo = card.querySelector('.price-info');
    if (!priceInfo) return;
    
    // Clear the placeholder
    priceInfo.innerHTML = '';
    
    // Use TradingView widget instead of custom layout
    createTradingViewWidget(priceInfo, symbol);
}

// Create TradingView single quote widget
function createTradingViewWidget(priceInfo, symbol) {
    const quoteWidget = document.createElement('div');
    quoteWidget.className = 'tradingview-widget-container';
    quoteWidget.style.width = '100%';
    quoteWidget.style.height = '120px';
    
    const widgetDiv = document.createElement('div');
    widgetDiv.className = 'tradingview-widget-container__widget';
    quoteWidget.appendChild(widgetDiv);
    
    priceInfo.appendChild(quoteWidget);
    
    // Load TradingView's single quote widget with real data
    // addScript(
    //     "https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js",
    //     {
    //         "symbol": symbol,
    //         "width": "100%",
    //         "isTransparent": true,
    //         "colorTheme": "light",
    //         "locale": "en",
    //         "autosize": true
    //     },
    //     quoteWidget
    // );
}

// Toggle individual stock card
function toggleStockCard(contentId, cardElement) {
    const content = document.getElementById(contentId);
    // const arrow = cardElement.querySelector('.card-arrow');
    
    // Find the parent stocks container for this specific block
    const parentBlock = cardElement.closest('.stocks-container');
    
    // Hide all other expanded content and remove active states ONLY within this block
    const allCards = parentBlock.querySelectorAll('.stock-toggle-card');
    const allContents = parentBlock.querySelectorAll('.stock-expanded-content');
    
    allCards.forEach(card => {
        card.classList.remove('active');
        // const cardArrow = card.querySelector('.card-arrow');
        // if (cardArrow) cardArrow.textContent = '▼';
    });
    
    allContents.forEach(expandedContent => {
        expandedContent.style.display = 'none';
    });
    
    if (content.style.display === 'none' || content.style.display === '') {
        // Show content
        content.style.display = 'block';
        // arrow.textContent = '▲';
        cardElement.classList.add('active');
        
        // Load stock data if not already loaded
        if (!loadedStocks.has(contentId)) {
            loadStockData(contentId, cardElement);
            loadedStocks.add(contentId);
        }
    }
}

// Load stock data and create full chart
function loadStockData(contentId, cardElement) {
    const content = document.getElementById(contentId);
    const symbol = cardElement.getAttribute('data-symbol');
    const label = cardElement.getAttribute('data-label');
    
    // Clear any existing content and show loading message
    content.innerHTML = '<div class="loading-message">Loading stock data...</div>';
    
    // Create the stock card using TradingView chart widget
    makeCard({label, tv: symbol}, content, contentId);
}

// Create a stock card with TradingView chart
function makeCard({label, tv}, root, contentId) {
    const card = document.createElement("div");
    card.className = "stock-card";

    // Quote row
    const row = document.createElement("div");
    row.className = "quote-wrap";
    card.appendChild(row);

    // Chart frame - USE CONTENT ID FOR UNIQUE CHART ID
    const cframe = document.createElement("div");
    cframe.className = "chart-frame";
    const cwrap = document.createElement("div");
    cwrap.className = "tradingview-widget-container";
    
    // Create unique chart ID using contentId
    const chartId = "tvchart-" + tv.replace(/[:.]/g, "-") + "-" + contentId.replace(/[^a-zA-Z0-9]/g, '-');
    const chartDiv = document.createElement("div");
    chartDiv.id = chartId;
    chartDiv.style.height = "460px";
    cwrap.appendChild(chartDiv);
    cframe.appendChild(cwrap);
    card.appendChild(cframe);

    // Mount card
    root.innerHTML = '';
    root.appendChild(card);

    // Create TradingView chart widget
    if (typeof TradingView !== 'undefined') {
        setTimeout(() => {
            try {
                // console.log('Creating chart with ID:', chartId, 'for symbol:', tv);
                new TradingView.widget({
                    container_id: chartId,
                    symbol: tv,
                    interval: "D",
                    autosize: true,
                    hide_top_toolbar: true,
                    hide_legend: false,
                    style: "3", // area/mountain
                    theme: "light",
                    studies: ["Volume@tv-basicstudies"],
                    // locale: "es",
                        // Add these parameters:
                    range: "12M",  // Options: "1D", "5D", "1M", "3M", "6M", "YTD", "12M", "60M", "ALL"
                    // // OR use specific dates:
                    // from: "2024-01-01",  // Start date (YYYY-MM-DD)
                    // to: "2024-12-31"     // End date (YYYY-MM-DD)
                });
            } catch (error) {
                console.warn('TradingView widget error for symbol:', tv, error);
            }
        }, 100);
    }
}

// Add script function
function addScript(src, jsonConfig, parent) {
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = src;
    s.innerHTML = JSON.stringify(jsonConfig);
    parent.appendChild(s);
}

// Make toggleStockCard available globally
window.toggleStockCard = toggleStockCard;